module.exports = "<form style=\"margin: 0;\" class=\"flexbox-container\">\n  <app-cce-search class=\"width-65\" required [(ngModel)]=\"selectedCce\" name=\"selectedCce\" (ngModelChange)=\"onCceChange($event)\"></app-cce-search>\n\n  <button *ngIf=\"eraseable\" mat-icon-button (click)=\"eraseMe()\">\n    <mat-icon>clear</mat-icon>\n  </button>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/book/cce-selector/cce-selector.component.html
// module id = ./src/app/components/book/cce-selector/cce-selector.component.html
// module chunks = main